import React, { useState } from 'react';

export const NotesEditor = ({ app, onSave }) => {
  const [notes, setNotes] = useState(app.notes || '');
  const [saving, setSaving] = useState(false);
  const dirty = notes !== (app.notes || '');

  const save = async () => {
    setSaving(true);
    await onSave(app.id, notes);
    setSaving(false);
  };

  return (
    <div>
      <label htmlFor={`notes-${app.id}`} className="text-xs uppercase tracking-wide text-gray-500">Private Staff Notes</label>
      <textarea
        id={`notes-${app.id}`}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        maxLength={5000}
        rows={3}
        placeholder="e.g. Interview set for Tue 10am; waiting on vaccination records"
        data-testid={`notes-input-${app.id}`}
        className="mt-1 w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <div className="flex items-center justify-between mt-2">
        <p className="text-xs text-gray-500">
          {app.notes_updated_by ? `Last saved by ${app.notes_updated_by}` : 'Only staff can see these notes.'}
        </p>
        <button onClick={save} disabled={!dirty || saving} data-testid={`notes-save-btn-${app.id}`}
          className="text-sm font-semibold px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-700 transition-colors disabled:opacity-40">
          {saving ? 'Saving…' : 'Save Notes'}
        </button>
      </div>
    </div>
  );
};
